import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';

import * as actions from './actions';

export type PatientInsuranceState = Readonly<{
  isFetching: boolean;
  error: Nullable<Error>;
  valid: boolean;
}>;

export const patientInsuranceInitialState: PatientInsuranceState = {
  isFetching: false,
  error: null,
  valid: false
};

export const patientInsuranceReducer = createReducer(patientInsuranceInitialState, {
  [actions.PATIENT_INSURANCE_VERIFICATION_STARTED]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.PATIENT_INSURANCE_VERIFICATION_ERROR]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.PATIENT_INSURANCE_VERIFICATION_COMPLETED]: (state, action) => {
    state.isFetching = false;
    state.valid = action.payload;
  },
  [actions.VERIFY_INSURANCE]: state => {
    state.isFetching = true;
    state.error = null;
    state.valid = false;
  },
  [actions.VERIFY_INSURANCE_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.VERIFY_INSURANCE_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.valid = action.payload.data;
  }
});

export default patientInsuranceReducer;
